import React from 'react';
import { Trophy } from 'lucide-react';
import { useTheme } from '../../../contexts/ThemeContext';
import MatchCard from '../brackets/MatchCard';

const StageMatch = ({ match, highlighted }) => {
  const { theme } = useTheme();
  return (
    <div className={`rounded-xl border p-3 ${highlighted ? `border-transparent ${theme.tabActive} ${theme.shadow}` : `${theme.border} ${theme.card}`}`}>
      <div className={`mb-2 flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wide ${highlighted ? '' : theme.textMuted}`}>
        {highlighted && <Trophy size={13} />}
        {match.stage}
      </div>
      <MatchCard match={match} compact />
      <p className={`mt-2 text-[11px] leading-snug ${highlighted ? '' : theme.textMuted}`}>{match.note}</p>
    </div>
  );
};

/**
 * The Page Playoff ladder (aka IPL Playoff / Double Chance Playoff): a fixed
 * 4-match shape, not a normal bracket, so it gets its own small diagram
 * instead of BracketBoard's round-column layout. Qualifier 1 and the
 * Eliminator run in parallel (left column) — seeds 1-2 get a second life if
 * they lose Qualifier 1 (they drop to Qualifier 2 instead of going out),
 * seeds 3-4 in the Eliminator don't get that cushion. Qualifier 2 and the
 * Final sit to the right, converging like any other playoff.
 */
const PagePlayoffView = ({ playoff }) => {
  const { theme } = useTheme();
  const [qualifiersRound, qualifier2Round, finalRound] = playoff;
  const [qualifier1, eliminator] = qualifiersRound.matches;
  const qualifier2 = qualifier2Round.matches[0];
  const final = finalRound.matches[0];

  return (
    <div>
      <p className={`mb-4 text-sm ${theme.textSecondary}`}>
        Top 4 from the league table. Seeds 1-2 get a "double chance" — lose Qualifier 1 and you still get one more
        shot in Qualifier 2. Seeds 3-4 in the Eliminator don't get that cushion.
      </p>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        <div className="space-y-4">
          <StageMatch match={qualifier1} />
          <StageMatch match={eliminator} />
        </div>
        <div className="flex items-center">
          <StageMatch match={qualifier2} />
        </div>
        <div className="flex items-center">
          <StageMatch match={final} highlighted />
        </div>
      </div>
    </div>
  );
};

export default PagePlayoffView;
